import classNames from 'classnames';
import PropTypes from 'prop-types';

const StaticIcon = ({ className }) => {
  const iconClassName = classNames('static-icon', className);

  return (
    <svg className={iconClassName} width='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.25 1C0.25 0.585786 0.585786 0.25 1 0.25H19C19.4142 0.25 19.75 0.585786 19.75 1V19C19.75 19.4142 19.4142 19.75 19 19.75H1C0.585786 19.75 0.25 19.4142 0.25 19V1ZM1.75 1.75V18.25H18.25V1.75H1.75Z'
        fill='currentColor'
      />
      <circle cx='6' cy='6' r='2' fill='currentColor' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1 0C0.447715 0 0 0.447715 0 1V19C0 19.5523 0.447715 20 1 20H19C19.5523 20 20 19.5523 20 19V1C20 0.447715 19.5523 0 19 0H1ZM2 17.7085V2H18V12.1314L12.9397 8.75781L2 17.7085Z'
        fill='currentColor'
      />
    </svg>
  );
};

StaticIcon.propTypes = {
  className: PropTypes.string,
};

export default StaticIcon;
